export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"og:url","property":"og:url","content":"http://localhost"},{"hid":"keywords","name":"keywords","content":"injective protocol, bridge, dapp, decentralized app, cryptocurrency, cryptocurrency exchange, exchange, ethereum, erc20, cosmos, injective, ibc, cross-chain"},{"hid":"description","name":"description","content":"Effortlessly bridge various crypto assets from Ethereum, Solana, Polygon, Cosmos IBC, and more onto Injective with its reliable and efficient protocol bridge solution."},{"hid":"author","name":"author","content":"InjectiveLabs"},{"hid":"og:type","property":"og:type","content":"bridge"},{"hid":"og:image","property":"og:image","content":"http://localhost/share-bridge.webp"},{"hid":"og:description","property":"og:description","content":"Effortlessly bridge various crypto assets from Ethereum, Solana, Polygon, Cosmos IBC, and more onto Injective with its reliable and efficient protocol bridge solution."},{"hid":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","property":"twitter:site","content":"@InjectiveLabs"},{"name":"twitter:image","content":"http://localhost/share-bridge.webp"},{"hid":"twitter:creator","property":"twitter:creator","content":"@InjectiveLabs"},{"hid":"twitter:description","property":"twitter:description","content":"Effortlessly bridge various crypto assets from Ethereum, Solana, Polygon, Cosmos IBC, and more onto Injective with its reliable and efficient protocol bridge solution."},{"hid":"twitter:title","property":"twitter:title","content":"Injective Bridge: Seamlessly Transfer Assets to Injective"},{"hid":"og:title","property":"og:title","content":"Injective Bridge: Seamlessly Transfer Assets to Injective"},{"hid":"og:site_name","property":"og:site_name","content":"Injective Bridge: Seamlessly Transfer Assets to Injective"},{"hid":"title","property":"title","content":"Injective Bridge: Seamlessly Transfer Assets to Injective"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon.png"},{"rel":"shortcut icon","type":"image/png","href":"/favicon.png"},{"rel":"apple-touch-icon","type":"image/png","href":"/favicon.png"}],"style":[],"script":[{"innerHTML":"var exports = {}"},{"src":"https://widget.mercuryo.io/embed.2.0.js"}],"noscript":[],"title":"Injective Bridge: Seamlessly Transfer Assets to Injective","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false